import { createBrowserRouter, type RouteObject } from 'react-router-dom';

import { MarketingLayout } from './app/layouts/MarketingLayout';
import { AppLayout } from './app/layouts/AppLayout';
import { AuthBootstrap, RequireAuth, RequireAnon } from './app/providers/AuthGate';

import { LandingPage } from './pages/marketing/LandingPage';
import { DocsPage } from './pages/marketing/DocsPage';
import { LoginPage } from './pages/auth/LoginPage';
import { AcceptInvitePage } from './pages/auth/AcceptInvitePage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { DashboardPage } from './pages/app/DashboardPage';
import { CarsListPage } from './pages/app/cars/CarsListPage';
import { NewCarPage } from './pages/app/cars/NewCarPage';
import { CarDetailPage } from './pages/app/cars/CarDetailPage';
import { CapturePage } from './pages/app/cars/CapturePage';
import { BackgroundsPage } from './pages/app/BackgroundsPage';
import { OverlaysPage } from './pages/app/OverlaysPage';
import { UsersPage } from './pages/app/UsersPage';
import { SettingsPage } from './pages/app/SettingsPage';

const routes: RouteObject[] = [
  {
    element: (
      <AuthBootstrap>
        <RequireAnon />
      </AuthBootstrap>
    ),
    children: [
      {
        element: <MarketingLayout />,
        children: [
          { index: true, element: <LandingPage /> },
          { path: 'docs', element: <DocsPage /> },
        ],
      },
      { path: 'login', element: <LoginPage /> },
      { path: 'accept-invite', element: <AcceptInvitePage /> },
      { path: 'forgot-password', element: <ForgotPasswordPage /> },
      { path: 'reset-password', element: <ResetPasswordPage /> },
    ],
  },
  {
    path: '/app',
    element: (
      <AuthBootstrap>
        <RequireAuth />
      </AuthBootstrap>
    ),
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'cars', element: <CarsListPage /> },
          { path: 'cars/new', element: <NewCarPage /> },
          { path: 'cars/:id', element: <CarDetailPage /> },
          { path: 'backgrounds', element: <BackgroundsPage /> },
          { path: 'overlays', element: <OverlaysPage /> },
          { path: 'users', element: <UsersPage /> },
          { path: 'settings', element: <SettingsPage /> },
        ],
      },
      { path: 'cars/:id/capture', element: <CapturePage /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
